/** biome-ignore-all lint/suspicious/noArrayIndexKey: array index keys needed for tab navigation */
import {
	For,
	Tabs,
	type TabsContentProps,
	type TabsListProps,
	type TabsTriggerProps,
} from '@chakra-ui/react';

interface IFaceliftListProps extends TabsListProps {
	children: React.ReactNode;
	bg?: string | { _dark: string; _light: string };
}
interface IFaceliftTriggerProps extends TabsTriggerProps {
	children: React.ReactNode;
	value: string;
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	fontWeight?: string;
}
interface IFaceliftContentProps extends TabsContentProps {
	children: React.ReactNode;
	value: string;
	_open?: {
		animationName: string;
		animationDuration: string;
	};
	_closed?: {
		animationName: string;
		animationDuration: string;
	};
}

const CustomTabs = {
	Root: (props: React.ComponentProps<typeof Tabs.Root>) => (
		<Tabs.Root {...props} />
	),
	List: (props: IFaceliftListProps) => <Tabs.List {...props} />,
	Trigger: (props: IFaceliftTriggerProps) => <Tabs.Trigger {...props} />,
	Content: (props: IFaceliftContentProps) => <Tabs.Content {...props} />,
};

interface FaceliftTabsProps {
	titles: string[];
	contents: React.ReactNode[];
	value: string;
	onValueChange: (value: string) => void;
}

const FaceliftTabs: React.FC<FaceliftTabsProps> = ({
	titles,
	contents,
	value,
	onValueChange,
	...rest
}) => {
	return (
		<CustomTabs.Root
			value={value}
			onValueChange={(val: { value: string }) => onValueChange(val.value)}
			colorPalette="brand"
			{...rest}
		>
			<CustomTabs.List
				bg="brand.headerBackground"
			>
				<For each={titles}>
					{(title, index) => (
						<CustomTabs.Trigger fontWeight="bold" size="md" key={index} value={index.toString()}>
							{title}
						</CustomTabs.Trigger>
					)}
				</For>
			</CustomTabs.List>

			{contents.map((content, idx) => (
				<CustomTabs.Content
					_open={{
						animationName: 'fade-in, scale-in',
						animationDuration: '300ms',
					}}
					_closed={{
						animationName: 'fade-out, scale-out',
						animationDuration: '120ms',
					}}
					key={idx}
					value={idx.toString()}
				>
					{content}
				</CustomTabs.Content>
			))}
		</CustomTabs.Root>
	);
};

export default FaceliftTabs;
